// @flow
import React from "react";
import UnderGround from "../../../svg/facilities/is_underground.svg";
import "./underGroundIcon.scss";

const UnderGroundIcon = () => <UnderGround className="c-under-ground-icon" />;

export default UnderGroundIcon;
